<template>
  <div id="services" class="services container-fluid">
      <div class="row justify-content-center service-row pb-3">
          <div class="col-12 text-center">
              <div class="row service-header">
                <div class="col-sm-12 col-lg-5">              
                    <img src="../assets/img/developers.png" alt="" class="mt-5">
                </div>
                  <div class="align-self-center col-sm-12 col-lg-7 pt-3">
                    <h1>Our Services</h1>
                    <h2 class="text-center px-sm-1 px-lg-5 mt-sm-1 mt-lg-5">Expertise and passion to build solutions</h2>
                  </div>
              </div>
          </div>
          <div v-for="(card, index) in services" :key="index" class="col-sm-12 col-md-4 col-lg-4 my-3">
                <div class="card service-card">
                    <div class="media-body">
                    <h3 class="m-3 text-center">{{card.title}}</h3>
                    <div class="service-list mb-5" v-html="card.description"></div>
                </div>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'Services',
    data(){
        return {
            services: [
                {
                    title: 'Mobile & Software Development ',
                    src: require('@/assets/img/code_developers.svg'),
                    description: `<ul>
                                    <li>Digital and technology solutions that boost your company's performance.</li>
                                    <li>End-to-End software development solutions.</li>
                                    <li>Cost-effective custom software solutions.</li>
                                    <li>Tracking of progress made easy with suitable methodolgies and project management tools.</li>
                                    <li>Full team dedicated to your solution: Project Manager/Scrum Master, SW/QA Engineers.</li>
                                </ul>`
                },
                {
                    title: 'IT Staff Augmentation',
                    src: require('@/assets/img/collaborate.svg'),
                    description: `<ul>
                                    <li>Time based software engineers to carry your projects.</li>
                                    <li>Support on the different stages of your projects: prototyping, development, testing, etc.</li>
                                    <li>Commitment, quality and professionalism within your team.</li>
                                </ul>`
                },
                {
                    title: 'Information Technology Services',
                    src: require('@/assets/img/collaborate.svg'),
                    description: `<ul>
                                    <li>Infrastructure.</li>
                                    <li>Application Servers.</li>
                                    <li>Messaging Servers.</li>
                                    <li>Virtualization.</li>
                                    <li>Container.</li>
                                    <li>DevOps.</li>
                                    <li>Cloud Computing Management.</li>
                                </ul>`
                }
            ]
        }
    },
    methods: {
        
    }
}
</script>

<style scoped>
    .service-row {
        box-shadow: 0px -4px 18px -9px rgba(82,80,82,0.82);
    }
    .service-image {
        width: 40%;
    }
</style>>